import { toast } from "react-toastify";
import { axiosClient } from "../../config";
import { GET_POST_VALIDATE_MAIL_URL, GET_RESERVATION_URL } from "../../utilities/constants";
import { resetReservation, setClientAddressReservation, setClientTaxReservation, setEmailClient, setPhoneClient, setRequireInvoice, setReservation } from "./reservationSlice";
import { startShowLoader, stopShowLoader } from "../loader";
import i18n from "../../config/lang";

const t = i18n.t;
export const startGetReservation = ({ reservationId }) => {
    return async( dispatch ) => {
        dispatch( startShowLoader() );
        const { status: statusResponse, data: response } = await axiosClient.post(GET_RESERVATION_URL, {
            reservationId
        })
        .catch(e => e);

        dispatch( stopShowLoader() );
        if (statusResponse != 200 || response?.type != "success") {
            dispatch( setReservation(null) );
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }

        dispatch( setReservation(response.data) );
        return true;
    }
}

export const startEditClientAddress = (clientAddress) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            dispatch( setClientAddressReservation(clientAddress) );
            dispatch( stopShowLoader() );
            return true;
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false
        }
    }
}

export const startEditClientTaxData = (clientTaxData) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            dispatch( setClientTaxReservation(clientTaxData) );
            dispatch( stopShowLoader() );
            return true;
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startEditEmailClient = ({ email }) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            const { status: statusResponse, data: response } = await axiosClient.post(GET_POST_VALIDATE_MAIL_URL, {
                email
            })
            .catch(e => e);
            dispatch( stopShowLoader() );
            if (statusResponse != 200 || response?.type != "success") {
                toast.error(response?.message ?? t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
                return false;
            }else{
                toast.success(response.message);
            }
            dispatch( setEmailClient(email) );
            return true;
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startEditPhoneClient = (phone) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            dispatch( setPhoneClient(phone) );
            dispatch( stopShowLoader() );
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startEditIsInvoiceClient = (invoiceRequired) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            dispatch( setRequireInvoice(invoiceRequired) );
            dispatch( stopShowLoader() );
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startResetReservation = () => {
    return async ( dispatch ) => {
        try {
            dispatch( resetReservation() );
        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}
